import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Tooltip,
  Snackbar,
  Grid,
  Box,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const prompts = [
  "Explain React in simple terms.",
  "function to reverse a string in JavaScript.",
  "Give me 5 UI tips for mobile design.",
  "Create a SQL query to get top 5 selling products.",
  "Generate a cover letter for a frontend developer job."
];

const PromptPage = () => {
  const [copiedPrompt, setCopiedPrompt] = useState('');
  const [open, setOpen] = useState(false);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopiedPrompt(text);
    setOpen('Prompt copied!');
  };

  return (
    <Box sx={{ p: 3 }}>

      <h2 >{' Prompt Library'}</h2>

      <Box mt={2}>
        <Grid container spacing={3}>
          {prompts.map((prompt, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card variant="outlined">
                <CardContent
                  sx={{
                    display: 'flex',
                    minHeight: 100,
                    position: 'relative',
                    alignItems: 'baseline',
                    justifyContent: 'space-between',
                    p: 2,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    {prompt}
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                    <Tooltip title="Copy to clipboard">
                      <IconButton onClick={() => handleCopy(prompt)} aria-label="copy">
                        <ContentCopyIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>

                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

    </Box>
  );
};

export default PromptPage;
